class ToggleButton {
  constructor(element) {
    element.addEventListener("click", this.onClick.bind(this));

    this.element = element;
    this.target = document.querySelector(`${element.dataset.target}`);
    this.init();
  }

  init() {

    


  }
  //   var numberOfFileDownloads = document.getElementsByClassName("filedownloadblock__grid-item").length;
  //   var showMoreButton = document.getElementById("show-more-button");
    
  //   // console.log(numberOfFileDownloads);

  //   if (numberOfFileDownloads <= 6) {
  //     showMoreButton.style.display = "none";
  //   } else {
  //     showMoreButton.style.display = "block";
  //   }
  // }



   onClick() {
    var buttonTextToggle = document.getElementById("show-more-button");
      // var shownDivs = document.querySelectorAll(".filedownloadblock__grid-item");

      
      // shownDivs.forEach((shownDiv) => {
      //   console.log(shownDiv);

      //   if(shownDiv.classList.contains("testclass")) {
      //       console.log("okej");
      //   } else {
      //     shownDiv.classList.add("hidden");
      //     shownDiv.classList.toggle("hidden"); 
      //   }
      // });

      if (buttonTextToggle.innerHTML === "Show more +") {
        buttonTextToggle.innerHTML = "Swapped text!";
      } else {
        buttonTextToggle.innerHTML = "Hello";
      }




    // if (buttonTextToggle.innerHTML === "Show more +") {
    //   buttonTextToggle.innerHTML = "Show less -";
    //   // shownDiv.classList.remove("hidden");
    //   //on click, show the divs that are hidden 

    //  } else {
    //    buttonTextToggle.innerHTML = "Show more +";
    //   // set class to hide the divs after 6th div. 

    //  }

    //  if (buttonTextToggle.innerHTML === "Show less -") {
    //   buttonTextToggle.innerHTML = "Show more +";
    //   // shownDiv.classList.remove("hidden");
    //   //on click, show the divs that are hidden 

    //  } else {
    //    buttonTextToggle.innerHTML = "Show less -";
    //   // set class to hide the divs after 6th div. 

    //  }



     console.log("click test");
       
        var paperJournalBoxes = document.querySelectorAll(".paperjournalblock__row");

    
        paperJournalBoxes.forEach((paperJournalBox) => {
          console.log(paperJournalBox);
          paperJournalBox.classList.toggle("paperjournalblock__five-items");
        });
   }
}

export default ToggleButton;


